import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, MessageCircle, ChevronDown } from "lucide-react";
import { businessInfo, applianceMeta } from "../constants";

const mainLinks = [
  { label: "Home", to: "/" },
  { label: "Service Charges", to: "/service-charges" },
  { label: "Service Areas", to: "/service-areas" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (to) => (to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(to));

  return (
    <>
      <div className="hidden md:block bg-[#0b1220] text-white text-xs">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-2">
          <div className="flex items-center gap-6 text-white/80">
            <span>{businessInfo.hours}</span><span>·</span><span>{businessInfo.location}</span>
          </div>
          <div className="flex items-center gap-5">
            <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-2 hover:text-[#e30613] transition-colors">
              <Phone className="w-3.5 h-3.5" /> {businessInfo.phoneDisplay}
            </a>
            <a href={businessInfo.whatsapp} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#25D366] transition-colors">
              <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
            </a>
          </div>
        </div>
      </div>

      <header className={`sticky top-0 z-40 transition-shadow ${scrolled ? "shadow-sm bg-white/95 backdrop-blur" : "bg-white"}`}>
        <div className="max-w-7xl mx-auto px-6 py-3.5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-11 h-11 bg-[#e30613] text-white grid place-items-center font-bold text-xl rounded-md">R</div>
            <div className="leading-tight">
              <div className="font-display text-lg font-semibold">Revive Solutions</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Authorised Elica Service</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            <Link to="/" className={`link-underline text-sm font-medium uppercase tracking-wide ${isActive("/") && loc.pathname === "/" ? "active text-[#e30613]" : ""}`}>Home</Link>
            <div className="relative" onMouseEnter={() => setDropdown(true)} onMouseLeave={() => setDropdown(false)}>
              <button className="link-underline text-sm font-medium uppercase tracking-wide flex items-center gap-1">
                Services <ChevronDown className="w-3.5 h-3.5" />
              </button>
              {dropdown && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 z-50">
                  <div className="bg-white border border-neutral-200 shadow-xl rounded-md py-2 min-w-[240px]">
                    {Object.values(applianceMeta).map((a) => (
                      <Link key={a.slug} to={a.route} className="block px-5 py-2.5 text-sm hover:bg-neutral-50 hover:text-[#e30613] transition-colors">
                        {a.label} Service
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {mainLinks.slice(1).map((l) => (
              <Link key={l.to} to={l.to} className={`link-underline text-sm font-medium uppercase tracking-wide ${isActive(l.to) ? "active text-[#e30613]" : ""}`}>
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link to="/book-service" className="btn-primary">Book a Service</Link>
          </div>

          <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden border-t border-neutral-200 bg-white">
            <div className="px-6 py-4 flex flex-col gap-2">
              {mainLinks.map((l) => (
                <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="py-2 text-sm font-medium uppercase tracking-wide">{l.label}</Link>
              ))}
              <div className="border-t border-neutral-200 mt-2 pt-2">
                <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-2">Appliance Services</div>
                {Object.values(applianceMeta).map((a) => (
                  <Link key={a.slug} to={a.route} onClick={() => setOpen(false)} className="block py-1.5 text-sm">{a.label} Service</Link>
                ))}
              </div>
              <Link to="/book-service" onClick={() => setOpen(false)} className="btn-primary w-max mt-3">Book a Service</Link>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
